module.exports = __webpack_public_path__ + "media/vid-slide-0.95242866.mp4";